(ns portfolio.scroll-spy
  "IntersectionObserver that dispatches ::events/set-active-section so the
  nav highlights whichever section the user is reading. Section entrance
  animations are CSS-only — see main.css `@keyframes fade-up`."
  (:require [re-frame.core :as rf]
            [portfolio.events :as events]))

(defonce ^:private observer (atom nil))

(defn- handle-entries [entries]
  (let [most-visible (->> entries
                          (filter #(.-isIntersecting %))
                          (sort-by #(.-intersectionRatio %) >)
                          first)]
    (when most-visible
      (let [id      (.. most-visible -target -id)
            section (keyword id)]
        (rf/dispatch [::events/set-active-section section])))))

(defn install! [section-ids]
  (when @observer (.disconnect ^js @observer))
  (let [obs (js/IntersectionObserver.
             handle-entries
             #js {:rootMargin "-30% 0px -50% 0px"
                  :threshold  #js [0 0.25 0.5 0.75 1]})]
    (doseq [id section-ids]
      (when-let [el (.getElementById js/document id)]
        (.observe obs el)))
    (reset! observer obs)))
